import {showNotification} from 'platform/components';
import {match} from 'ts-pattern';

import {Navigate} from 'react-router-dom';

import {always, isNil} from 'ramda';

import {TemplateTypeEnum} from '@dms/api/core';
import {settingsRoutes} from '@dms/routes';

import {useRequiredParams} from 'shared/web';

import {EditMessageTemplateForm} from './components/EditMessageTemplateForm';

export const MessageTemplateEdit = () => {
  const {id, type} = useRequiredParams();

  const templateType = match<string, TemplateTypeEnum | null>(type)
    .with('email', 'e-mail', always('email'))
    .with('sms', always('sms'))
    .with('chat', always('chat'))
    .otherwise(always(null));

  if (isNil(templateType)) {
    showNotification.error('Invalid template type');
    return <Navigate to={settingsRoutes.messageTemplates} />;
  }

  return <EditMessageTemplateForm templateType={templateType} messageTemplateId={id} />;
};
